import { createFileRoute, useNavigate } from '@tanstack/react-router';
import { GroupProfile } from '@/components/group-profile';

export const Route = createFileRoute('/_app/groups_/$id')({ component: GroupProfilePage });
function GroupProfilePage() {
  const { id } = Route.useParams();
  const navigate = useNavigate();
  return <GroupProfile id={id} onBack={() => void navigate({ to: '/groups' })} />;
}
